import { useEffect, useState } from "react";
import { Form, Col, Row, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import {
  CheckCircleOutlined,
  CloseOutlined,
  DeleteOutlined,
  PlusOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
// import AccountForm from "../../../global/components/adminInfo";
// import AccountCreationModal from "../../../global/components/AccountCreationModal";
// import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import { RiAlignItemBottomFill } from "react-icons/ri";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import useDelete from "../../../global/hooks/useDelete";
import ConfirmModal from "../../../global/components/ConfirmModal";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { ProductionItemsInfoColumns } from "../Page/ProductionItemsInfoColumns";
import ProductionModal from "./ProductionModal";

export const ProductionItemForm = ({
  type,
  isModalForm,
  onCancel,
  productionRefetch,
}) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [openModal, setOpenModal] = useState({
    addByCountModal: false,
    addByListModal: false,
  });
  // const [isOpenModal, setIsOpenModal] = useState(false);
  // const [modalType, setModalType] = useState("");
  // const [defaultData, setDefaultData] = useState({
  //   OemNo: "",
  //   LicenseNo: null,
  //   ItemCount: 100,
  // });
  const [hoveredRow, setHoveredRow] = useState(null);

  const [form] = Form.useForm();
  const { id, itemid } = useParams();

  const navigate = useNavigate();
  const url =
    id &&
    itemid &&
    `${process.env.REACT_APP_API_URL}/api/${id}/production-items/${itemid}/`;
  const hardwareurl = `${process.env.REACT_APP_API_URL}/api/hardwares/?limit=100&order=desc`;
  const postUrl = `${process.env.REACT_APP_API_URL}/api/${id}/production-items/`;
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/${id}/production-items/bulk-delete-item-device/`;
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/dealers/options/`;
  // const licenseParams = {
  //   limit: 100,
  //   sort_by: "LicenseNo",
  //   order: "asc",
  // };
  // const licenseQuery = new URLSearchParams(licenseParams).toString();
  // const licenseUrl = loggedInUser?.role_value
  //   ? `${process.env.REACT_APP_API_URL}/api/licenses/?${licenseQuery}`
  //   : null;

  // const { data: licenseData } = useGet(licenseUrl);

  const { data, loading, error, refetch } = useGet(url);
  const {
    data: hardwareData,
    loading: hardwareLoading,
    error: hardwareError,
    refetch: hardwareRefetch,
  } = useGet(hardwareurl);

  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteMultiple,
  } = useDelete(deleteUrl);

  const {
    data: optionData,
    loading: optionDataLoading,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);
  const modifiedOems = getModifiedResponse(optionData, "oems");
  const modifiedHardwares =
    hardwareData?.data?.map((item) => ({
      label: item.HardwareName,
      value: item.HardwareNo,
    })) || [];
  const modifiedLicenses = getModifiedResponse(optionData, "licenses");
  // const modifiedBillingCycles = getModifiedResponse(optionData, "bill_cycles");
  // const modifiedAutoBilling = getModifiedResponse(optionData, "auto_billings");

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(postUrl);

  const onFinish = async (values) => {
    const modValues = {
      ...values,
    };
    try {
      await postAction(modValues);
    } catch (error) {
      openErrorNotification("Something went wrong.");

      console.log(error);
    }
  };

  // Set default field value
  // useEffect(() => {
  //   if (!type) {
  //     form.setFieldsValue({
  //       OemNo: modifiedOems[0]?.value,
  //     });
  //   }
  // }, [modifiedOems]);

  const onDeleteConfirm = async () => {
    try {
      await deleteMultiple({
        device_ids: selectedRowKeys,
        production_item_id: Number(itemid),
      });
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    // navigate(`/oemlist/${newSelectedRowKeys}`);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };
  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
        // navigate(`/production/info/${record?.ProductionNo}`);
      },
    };
  };
  //toat for 404
  useEffect(() => {
    if (error) {
      openErrorNotification("Not found");
      navigate("/production");
    }
  }, [error]);

  useEffect(() => {
    if (!type || loading) {
      form.setFieldsValue({
        ItemCount: 100,
      });
    } else {
      const getAccountInfoById = () => {
        try {
          if (data?.data) {
            form.setFieldsValue({
              Oem: data?.data?.Oem,
              Product: data?.data?.Product,
              HardwareNo: data.data.HardwareNo,
              LicenseNo: data.data.LicenseNo,
              ItemCount: data.data.ItemCount,
              DeviceCount: data.data.DeviceCount,
            });
          } else {
            console.warn("No data found for the given ID");
          }
        } catch (error) {
          if (!loading) {
            openErrorNotification("Error fetching data!");
          }
        }
      };

      getAccountInfoById();
    }
  }, [id, data, loading, form]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postLoading && !postError && postData) {
      openConfirmNotification("Success");
      isModalForm && productionRefetch();
      setTimeout(() => {
        isModalForm ? onCancel() : navigate(-1);
      }, 200);
    }
  }, [postError, postData, postLoading]);

  //toast for delete
  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      refetch();
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    } else {
      return;
    }
  }, [deletedData, deletedDataError]);

  const breadcrumbItems = [
    {
      label: "Production Item",
      href: `/production/info/${id}`,
    },
    {
      label: type === "info" ? "Information" : "Add",
      href:
        type === "info"
          ? `/production/info/${id}`
          : `/productionitem/add/${id}`,
    },
  ];

  const buttonsData =
    type === "info"
      ? [
          {
            label: "List",
            icon: <UnorderedListOutlined />,
            onClick: () => {
              navigate(-1);
            },
          },
        ].filter(Boolean)
      : [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: () => {
              navigate(-1);
            },
          },
        ];

  const productionItemButtonsData = [
    {
      label: "Add by Count",
      icon: <PlusOutlined />,
      onClick: () => {
        // navigate(`/addproductionbycount/${id}/info/${itemid}`);
        setOpenModal((prev) => ({
          ...prev,
          addByCountModal: true,
        }));
      },
      disabled: data?.data?.DeviceCount >= data?.data?.ItemCount,
    },
    {
      label: "Add by List",
      icon: <PlusOutlined />,
      onClick: () => {
        // navigate(`/addproductionbylist/${id}/info/${itemid}`);
        setOpenModal((prev) => ({
          ...prev,
          addByListModal: true,
        }));
      },
      disabled: data?.data?.DeviceCount >= data?.data?.ItemCount,
    },
    {
      label: "Delete",
      icon: <DeleteOutlined />,
      onClick: () => {
        setShowModal(true);
      },
      disabled: selectedRowKeys?.length === 0 ? true : false,
    },
  ];

  // const handleCreateNew = (type) => {
  //   setModalType(type);
  //   setIsOpenModal(true);
  // };
  // useEffect(() => {
  //   optionDataRefetch();
  //   if (defaultData?.OemNo) {
  //     form.setFieldsValue(defaultData);
  //   }
  // }, [defaultData]);

  return (
    <>
      {/* <AccountCreationModal
        isOpenModal={isOpenModal}
        // modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        // setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {`Add ${modalType}`}
            </span>
          </div>
        }
      /> */}
      <Form
        validateTrigger={"onChange"}
        form={form}
        onFinish={onFinish}
        scrollToFirstError
        layout={"vertical"}
        autoComplete={"off"}
      >
        <div>
          {!isModalForm && (
            <div
              className={`pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]`}
            >
              <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
                <CommonButton buttonsData={buttonsData} />
              </CommonBreadcrumb>
            </div>
          )}

          <div
            className={`${
              isModalForm ? "" : "bg-white overflow-hidden border rounded-[4px]"
            }`}
          >
            {!isModalForm && (
              <div className="flex items-center bg-gray-200 p-2.5">
                <RiAlignItemBottomFill className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2 ">
                  Production Item
                </span>
              </div>
            )}

            <div className={`px-2 pt-0 pb-3`}>
              <Row gutter={[16, 8]}>
                <Col
                  xs={24}
                  sm={24}
                  md={isModalForm ? 24 : 12}
                  lg={isModalForm ? 24 : 12}
                  xl={isModalForm ? 24 : 12}
                  span={24}
                >
                  <CustomSelect
                    label="Hardware"
                    name="HardwareNo"
                    options={modifiedHardwares}
                    placeholder="Please select"
                    required
                    disabled={type === "info"}
                    loading={loading}
                  />
                </Col>
                {type === "info" && (
                  <Col
                    xs={24}
                    sm={24}
                    md={isModalForm ? 24 : 12}
                    lg={isModalForm ? 24 : 12}
                    xl={isModalForm ? 24 : 12}
                    span={24}
                  >
                    <CustomSelect
                      label="OEM"
                      name="Oem"
                      options={modifiedOems}
                      placeholder="Please select"
                      // required
                      // handleCreateNew={handleCreateNew}
                      type={"OEM"}
                      disabled
                      loading={loading}
                    />
                  </Col>
                )}
                {type === "info" && (
                  <Col
                    xs={24}
                    sm={24}
                    md={isModalForm ? 24 : 12}
                    lg={isModalForm ? 24 : 12}
                    xl={isModalForm ? 24 : 12}
                    span={24}
                  >
                    <CustomInput
                      label="Product"
                      name="Product"
                      disabled
                      loading={loading}
                    />
                  </Col>
                )}
                <Col
                  xs={24}
                  sm={24}
                  md={isModalForm ? 24 : 12}
                  lg={isModalForm ? 24 : 12}
                  xl={isModalForm ? 24 : 12}
                  span={24}
                >
                  <CustomSelect
                    label="License"
                    name="LicenseNo"
                    options={modifiedLicenses}
                    placeholder="Please select"
                    required
                    disabled={type === "info"}
                    loading={loading}
                  />
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={isModalForm ? 24 : 12}
                  lg={isModalForm ? 24 : 12}
                  xl={isModalForm ? 24 : 12}
                  span={24}
                >
                  <CustomInput
                    label="Item Count"
                    name="ItemCount"
                    type="number"
                    disabled={type === "info"}
                    loading={loading}
                  />
                </Col>
                {type === "info" && (
                  <Col
                    xs={24}
                    sm={24}
                    md={isModalForm ? 24 : 12}
                    lg={isModalForm ? 24 : 12}
                    xl={isModalForm ? 24 : 12}
                    span={24}
                  >
                    <CustomInput
                      label="Device Count"
                      name="DeviceCount"
                      type="number"
                      disabled
                      loading={loading}
                    />
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </div>
      </Form>

      {isModalForm && (
        <div className="flex justify-center space-x-2 mt-2.5">
          <Button
            type="primary"
            className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
            onClick={() => form.submit()}
            loading={postLoading}
            disabled={postLoading}
          >
            <CheckCircleOutlined className="!text-[14px] font-medium" />
            <span className="">Apply</span>
          </Button>
          <Button className="reset-button" onClick={onCancel}>
            <CloseOutlined />
            <span className="">Cancel</span>
          </Button>
        </div>
      )}

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
        setSelectedRowKeys={setSelectedRowKeys}
      />
      {type === "info" && (
        <>
          <div className="flex justify-end mb-2">
            <CommonButton buttonsData={productionItemButtonsData} />
          </div>
          <GlobalTable
            columns={ProductionItemsInfoColumns()}
            dataSource={
              data?.data?.Production_item_devices?.map((item) => ({
                ...item,
                key: item.DeviceNo,
                Oem: data?.data?.Oem,
              })) || []
            }
            rowSelection={rowSelection}
            // onRow={onRow}
            onRow={(record, rowIndex) => {
              return {
                onMouseEnter: () => setHoveredRow(rowIndex),
                onMouseLeave: () => setHoveredRow(null),
                ...onRow?.(record, rowIndex),
              };
            }}
            loading={loading}
          />
          {/* <ProductionModal
            isOpenModal={openModal.addByCountModal}
            setIsOpenModal={(value) =>
              setOpenModal((prev) => ({
                ...prev,
                addByCountModal: value,
              }))
            }
            productionRefetch={refetch}
            modalType="addByCount"
            title={
              <div className="flex items-center bg-gray-200 p-2 rounded-md">
                <RiAlignItemBottomFill className="text-[18px] text-black " />
                <span className="text-[14px] font-[Poppins] text-black  ml-2">
                  Add by Count
                </span>
              </div>
            }
          />
          <ProductionModal
            isOpenModal={openModal.addByListModal}
            setIsOpenModal={(value) =>
              setOpenModal((prev) => ({
                ...prev,
                addByListModal: value,
              }))
            }
            productionRefetch={refetch}
            modalType="addByList"
            title={
              <div className="flex items-center bg-gray-200 p-2 rounded-md">
                <RiAlignItemBottomFill className="text-[18px] text-black " />
                <span className="text-[14px] font-[Poppins] text-black  ml-2">
                  Add by List
                </span>
              </div>
            }
          /> */}
          <ProductionModal
            isOpenModal={openModal.addByCountModal || openModal.addByListModal}
            setIsOpenModal={(value) => {
              const modalType = openModal.addByCountModal
                ? "addByCountModal"
                : "addByListModal";
              setOpenModal((prev) => ({
                ...prev,
                [modalType]: value,
              }));
            }}
            LicenseNo={data?.data?.LicenseNo}
            productionRefetch={refetch}
            modalType={openModal.addByCountModal ? "addByCount" : "addByList"}
            title={
              <div className="flex items-center bg-gray-200 p-2 rounded-md">
                <RiAlignItemBottomFill className="text-[18px] text-black " />
                <span className="text-[14px] font-[Poppins] text-black  ml-2">
                  {openModal.addByCountModal ? "Add by Count" : "Add by List"}
                </span>
              </div>
            }
          />
        </>
      )}
    </>
  );
};
